import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLightcastToken } from "../redux/authSlice";
import { api1 } from "./axiosInstance";

const fetchLightcastToken = async () => {
  try {
    const response = await api1.get("/api/lightcast/get-token");
    const expiresAt = Date.now() + response.data.expires_in * 1000; // Convert expires_in to milliseconds
    return { token: response.data.access_token, expiresAt };
  } catch (error) {
    console.error("Error in fetchLightcastToken:", error);
    throw error;
  }
};

const useLightcastToken = () => {
  const dispatch = useDispatch();

  const lightCastToken = useSelector((state) => state.auth.lightcastToken);
  const tokenExpiresAt = useSelector(
    (state) => state.auth.lightcastTokenExpiresAt
  );
  const isLoggedIn = useSelector((state) => state.auth.token !== null);

  // Check if token is expired
  const isTokenExpired = !tokenExpiresAt || Date.now() > tokenExpiresAt - 30000; // Refresh 30 sec before expiry

  const { data, error, isFetching, refetch } = useQuery({
    queryKey: ["lightcastToken"],
    queryFn: fetchLightcastToken,
    enabled: isLoggedIn && (isTokenExpired || !lightCastToken), // Refetch if expired or missing
    staleTime: 1000 * 60 * 55, // 55 minutes
    cacheTime: 1000 * 60 * 60, // 1 hour
    retry: 1,
  });

  useEffect(() => {
    if (data) {
      dispatch(
        setLightcastToken({ token: data.token, expiresAt: data.expiresAt })
      );
    }
  }, [data, dispatch]);

  return {
    lightCastToken: isTokenExpired ? null : lightCastToken,
    error,
    isFetching,
    refetch,
  };
};

export default useLightcastToken;
